
  import {Component, Prop, Watch, Vue} from "vue-property-decorator";
  import { Alert } from "@/addons/Alert";
  import { useConsultorioStore } from '../../store/consultorioStore';
  import { globalStore } from '../../store/globalStore';
  import { consultorioService } from '../../services/ConsultorioService';
  
  @Component({
    name: "ModalOdonto"
  })
  export default class ModalOdonto extends Vue {
    @Prop() dialog!: boolean
    @Prop() pieza_id!: number
    @Prop() pieza_codigo!: number
    @Prop() paciente_id!: number

    private globalStore = globalStore();
    private consultorioStore = useConsultorioStore();
    private consultorioService = consultorioService.getInstance();
  
    swEditar = true;
    valid = true;
		tratamiento = null;
		caras_seleccionadas = []
		observacion = ''
		cita_id = null
    
    get otros_tratamientos(): any {
      return this.consultorioStore.otros_tratamientos;
    }
		get caras(): any {
      return this.consultorioStore.caras;
    }
		get citas(): any {
      return this.consultorioStore.citas;
    }
    mounted(){
      //this.getTiposUso();
      //this.de_editar()
    }
    
    // getClientesCuenta(value:string){
    //   this.loading
    //   this.ventaAguaService.getClientesCuenta(value)
    // }
    guardar() {
		if (!this.$refs.form.validate()) {
			Alert.warning(`Lene todos los campos obligatorios (*)`)
			return;
		}
    if(this.caras_seleccionadas.includes(7)){
      this.caras_seleccionadas.shift();
      const arriba = [4,5,2,3,6];
      const abajo = [4,5,2,1,3]
      if(this.pieza_codigo > 10 && this.pieza_codigo <= 28) this.caras_seleccionadas.push(...arriba)
      if(this.pieza_codigo >= 30 && this.pieza_codigo <= 48) this.caras_seleccionadas.push(...abajo)
    }
		let data = {
			cita_id: this.cita_id,
			pieza_dental_id: this.pieza_id,
			tratamiento_id: this.tratamiento.id,
			observacion: this.observacion,
			paciente_id: this.paciente_id,
			detalle_caras: this.caras_seleccionadas,
      color: this.tratamiento.color
		}
		if (this.swEditar) {
			Alert.confirm(`Se realizará el registro del tratamiento `, 'Registrar tratamiento?').then(async result => {
				if (result.isConfirmed) {
					await this.consultorioService.registrarDetalleOdontograma(data).then(response => {

						//this.limpiar()
						this.close()
						this.$emit('listar')
					})

				}
			})
		} else {
			Alert.confirm(`Se realizará la modificacion de la venta`, 'Modificar venta?').then(async result => {
				if (result.isConfirmed) {
					await this.consultorioService.editarVenta(this.venta)
					this.limpiar()
				}
			})
		}

	}
    close(){
      this.limpiar();
      this.$emit("close");
    }
    
    de_editar(){
      if( Object.entries(this.clienteEdit).length !== 0 && this.clienteEdit.constructor === Object){
        this.swEditar = false;
        
      }
    }
    limpiar(){
      return
    }
    get loading(): boolean {
      return this.consultorioStore.loading;
    }
    
  }
  